/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */
import transformNodeUrl from "url:../assets/images/transform_node.png";

export const transformNodesContent = `
## Summary

Transform nodes are the core of Dexter's functionality. They define how data is converted from one format to another.

Transform nodes take in data from an input node, transform the data, and then send it to an output node.  Therefore, they have both an input handle and an output handle.

### Transform Families & Types

Transform nodes are divided into families consisting of input and output data.  For example, Dexter has a **PX** transform family, which contains all of the transforms associated with (P)rotobuf to (X)ML conversions, so "PX" for short.

Transform nodes of a given family come in two varieties:
- **Full File** - Transforms all of the content inside of an input node
- **Granular** - Transforms specific "slices" of data from an input node

### Anatomy

<img src="${transformNodeUrl}" alt="Transform Node" style="max-width: 300px; height: auto; display: block; margin: 24px auto;" />

- **1** - Input handle, takes data from an input node edge connection
- **2** - Output handle, connects to the input handle of an output node
- **3** - Subtitle indicates the "type" of node, full-file or granular

### Supported Transforms

Dexter supports several transformation types as of the current version:

#### 1. Proto to XML (Full)
Transforms an entire Protocol Buffer file to XML format.

#### 2. Proto to XML (Granular)
Transforms individual Protocol Buffer data slices to XML.

#### 3. XML to Proto (Full)
Transforms an entire XML file to Protocol Buffer format.

#### 4. XML to Proto (Granular)
Transforms individual XML data slices to Protocol Buffer format.

### Creating Transforms

1. Click the transform button in the control bar
2. Select the type of transform you need
3. Drag the transform node onto the canvas
4. Connect input and output nodes

### Transform Validation

Dexter validates your transforms to ensure:
- Compatible input and output types
- Valid connection patterns
- Proper data structure mapping

The user receives a red toast on the upper right-hand corner of the screen in the event that the user has created a faulty connection to the transform node.

### Troubleshooting Transforms

If your transform isn't working:
- Check that input and output types are compatible
- Verify all required connections are made
- Review any error messages in the node
- Ensure input data is valid
`;
